import { useMemo } from 'react';

import useRolesData from '../api/queries/useRolesData.js';
import type { OptionItem } from '../types/shared.js';

const useRoleList = () => {
  const { data } = useRolesData();

  return useMemo<OptionItem[]>(() => {
    if (!data) {
      return [];
    }

    return data.map((item) => {
      return {
        value: String(item.id),
        label: item.name,
      };
    });
  }, [data]);
};

export default useRoleList;
